import type { OpenFundFormData } from '../schemas/openFundFormSchema';

/** JSON-safe snapshot of the form (no File blobs). Used for anonymous early-lead resume. */
export function serializeOpenFundFormForLead(form: OpenFundFormData): string {
  return JSON.stringify(form, (_key, value) => (value instanceof File ? null : value));
}

export function parseOpenFundFormLeadSnapshot(json: string): Partial<OpenFundFormData> | null {
  try {
    const parsed = JSON.parse(json) as Partial<OpenFundFormData>;
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch {
    return null;
  }
}
